import Home from './Home.svelte';

const AuctionGame = new Home({
	target: document.querySelector('#jnd-auction-game'),
	props: {
		isDevMode: document.querySelector('#jnd-auction-game').dataset.localenv === 'local'
	}
});

export default AuctionGame;